IREP.Nav = function () {
    $('nav [data-open]').on('click', function(e) {
        e.stopPropagation();
        var menuToOpen = $(e.target).data('open');
        $('nav .' + menuToOpen).toggle();
    });
    $(document).on('click', function(e) {
        var menu = $(e.target).closest('#mainMenu_inner').length;
        var profileMenu = $(e.target).closest('#userProfileMenu_inner').length;
        if (menu == 0 && profileMenu == 0) {
            $('.mainmenu, .userprofilemenu').hide();
        }
    });
    $(".xpbar").on("mouseover", function () {
        $("#xpHover").show();
    });
    $(".xpbar").on("mouseout", function () {
        $("#xpHover").hide();
    });
}
IREP.Footer = function () {
    $("#BackToTop").click(function () {
        $('html, body').animate({
            scrollTop: $("nav").offset().top
        }, 1000);
    });
}